import { IS_PRODUCTION } from "@/configs";

export const LOOTBOX_CONTRACT_ADDRESS = IS_PRODUCTION ? "0x517d38D55f9F47062B2E223349eb772C4686D17D" : "0xff6174156e98aa0a7124c26cda402C7b40682070";
// export const LOOTBOX_CONTRACT_ADDRESS = "0x517d38D55f9F47062B2E223349eb772C4686D17D";
